import React from "react";
import ReactDOM from "react-dom";
// Css Imports
import "./index.scss";

// Component Imports
import App from "./App";
// Service Worker Import
import * as serviceWorker from "./serviceWorker";
// Redux Imports
import { Provider } from "react-redux";
import { store } from "./redux/store";
// Localization Helper Import
import ConnectedIntlProvider from "components/ConnectedIntlProvide";
// Router Import
import { BrowserRouter as Router } from "react-router-dom";
import { PostHogProvider} from 'posthog-js/react'
import { createClient, AnalyticsProvider } from '@segment/analytics-react';

import "antd/dist/antd.css";

const segmentClient = createClient({
  writeKey: process.env.REACT_APP_PUBLIC_SEGMENT_WRITE_KEY
});
const options = {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
}

ReactDOM.render(
  <Provider store={store}>
    <ConnectedIntlProvider>
      <Router>
        <AnalyticsProvider client={segmentClient}>
          <PostHogProvider 
            apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY}
            options={options}
          >
            <App />
          </PostHogProvider>
        </AnalyticsProvider>
      </Router>
    </ConnectedIntlProvider>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
